// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2xhdP","icon":"SortAdornment_icon__3AmIK","up":"SortAdornment_up__2-h9U","down":"SortAdornment_down__1jLUa","active":"SortAdornment_active__1AGvY"};